import { Injectable } from '@angular/core';

import { RestService } from "../../../../../core/services/rest.service";
import { TipoMaterial } from "./material-tipo.model";
import { apiName } from "./data.service";

@Injectable()
export class MaterialTipoApiService {

  constructor(
    private _restService: RestService,
  ) { }

  onPost(object: TipoMaterial, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: TipoMaterial, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":["tipo"],"where":{"ativo":true}};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    this._restService.onGetPostId(apiName, objectId, {}, done);
  }

  onGetApiUrl() {
    return apiName;
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material/material-tipos/shared/material-tipo-api.service.ts
 **/